import * as Yup from 'yup';
import { datetimeFromUTC } from 'utils/dayjs';

const dateRegexp = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

export default Yup.object().shape( {
    firstName: Yup.string().required( 'Заполните поле' ),
    lastName: Yup.string().required( 'Заполните поле' ),
    email: Yup.string()
        .email('Неверный формат email')
        .required( 'Заполните поле' ),
    birthday: Yup.string().nullable()
        .required( 'Заполните поле' )
        .test( 'customerBirthday', 'Неверный формат даты', function ( value ) {
            if ( !value ) return false;
            if (new Date(datetimeFromUTC(value, true).date) >= new Date()) return false;
            return dateRegexp.test(datetimeFromUTC(value, true).date)
        } )
} );
